import { db } from '../config';
import { logMigration } from './migrationUtils';

export const featureConsolidation = async () => {
  const BATCH_SIZE = 500;
  const stats = {
    sitesProcessed: 0,
    mediaProcessed: 0,
    predictionsConverted: 0
  };

  try {
    // Get all sites
    const sitesSnapshot = await db.collection('sites').get();
    const sites = sitesSnapshot.docs;

    for (let i = 0; i < sites.length; i += BATCH_SIZE) {
      const batch = db.batch();
      const currentBatch = sites.slice(i, i + BATCH_SIZE);

      for (const siteDoc of currentBatch) {
        const site = siteDoc.data();
        let hasChanges = false;

        // Process media items
        if (Array.isArray(site.media)) {
          site.media = site.media.map(media => {
            if (!media) return media;

            // Initialize predictions array if it doesn't exist
            if (!Array.isArray(media.predictions)) {
              media.predictions = [];
            }

            // Convert old features to predictions
            if (media.features) {
              Object.entries(media.features).forEach(([featureId, feature]) => {
                if (feature?.enabled) {
                  // Only add if not already in predictions
                  const existingPred = media.predictions.find(p => 
                    p.class === featureId || p.featureId === featureId
                  );
                  
                  if (!existingPred) {
                    media.predictions.push({
                      class: featureId,
                      source: 'manual',
                      manual: true
                    });
                  }
                }
              });

              // Remove old features
              delete media.features;
              hasChanges = true;
            }

            // Normalize predictions
            if (media.predictions.length > 0) {
              media.predictions = media.predictions.map(pred => {
                if (!pred.source) {
                  // If no source but has confidence, it's from auto-detection
                  if (typeof pred.confidence === 'number') {
                    pred.source = 'auto';
                  } 
                  // If manual flag, it's a manual prediction
                  else if (pred.manual) {
                    pred.source = 'manual';
                  }
                  // If neither, assume it's a system prediction
                  else {
                    pred.source = 'system';
                  }
                }

                // Clean up redundant fields
                if (pred.source !== 'auto') {
                  delete pred.confidence;
                }
                delete pred.manual;

                return pred;
              });
              
              hasChanges = true;
            }

            return media;
          });

          stats.mediaProcessed += site.media.length;
          stats.predictionsConverted += site.media.reduce((count, media) => 
            count + (media?.predictions?.length || 0), 0);
        }

        if (hasChanges) {
          batch.update(siteDoc.ref, { media: site.media });
          stats.sitesProcessed++;
        }
      }

      await batch.commit();
      console.log(`Processed batch: ${i} to ${i + currentBatch.length} sites`);
    }

    await logMigration('featureConsolidation', stats);
    return { success: true, stats };

  } catch (error) {
    console.error('Feature consolidation migration failed:', error);
    return { success: false, error: error.message };
  }
};
